import { QUIZ_ROUTES } from '../quizzes/quizRoutes';

const returnPaths = new Set([QUIZ_ROUTES.list, QUIZ_ROUTES.start, QUIZ_ROUTES.testSeriesList]);

export function assessmentNavigation(value = {}) {
  const result = {};
  for (const key of ['quizId', 'seriesId']) {
    const id = Number(value?.[key]);
    if (Number.isSafeInteger(id) && id > 0) result[key] = id;
  }
  const target = value?.assessmentReturnTarget;
  if (target && returnPaths.has(target.pathname)) {
    result.assessmentReturnTarget = {
      pathname: target.pathname,
      state: target.state && typeof target.state === 'object' ? target.state : {},
    };
  }
  return result;
}
